import '@/features/trainings/styles/train.css';
import React from 'react';
import get_default_benchmarks_table_data from '@/features/datasets/components/benchmarks/DefaultBenchmarksData.jsx'
import { examplesData, processedDataInfo } from '@/features/datasets/components/datasets-page/ExploreDatasetsDefaultData.jsx';

import {
    SearchOutlined,
    RollbackOutlined,
    LoadingOutlined,
} from '@ant-design/icons';

import {
    AutoComplete,
    Card,
    Table,
    Button,
    Tooltip,
} from 'antd';

import { get_base_url } from '@/shared/http/client';
//import { examplesColumns, processedDataInfoColumns } from '@/features/datasets/components/datasets-page/ExploreDatasetsColumns.jsx';
import CheckModels from '@/features/datasets/components/ExploreDatasets/CheckModels.jsx';
import { colors } from '@/shared/tokens/colors';
import Statistics from '@/features/datasets/components/ExploreDatasets/Statistics.jsx';
import { examplesColumns, processedDataInfoColumns } from '@/features/datasets/components/datasets-page/ExploreDatasetsColumns.jsx';

const tableProps = {
    bordered: false,
    loading: false,
    showHeader: false,
    showFooter: false,
    footer: undefined,
    showTitle: false,
    pagination: false,
}

const datasetsOptions = [
    { value: "customer-support-chatbot" },
    { value: "customer-support-q&a" },
    { value: "customer-review-summarization" },
    { value: "status-update-classification" }
]


const modelsOptions = [
    { value: "Llama 3 8B - Instruct" },
    { value: "Llama 3 70B - Instruct" },
    { value: "Mistral 7B - Instruct" },
    { value: "Mixtral 8X7B - Instruct" }
]

const subStatisticCardStyle = { borderWidth: '3px' }

export class ExploreDatasets extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentOptions: datasetsOptions,
            datasets: [],
            loading: true,
            showSpecificData: (props.dataset || "").length > 1,
            searchValue: props.dataset,
            vocabValue: "",
            sampleSize: 10,
            showVocabResult: false,
            showPerplexity: false,
            currentModelsOptions: ["Llama 3 8B - Instruct",
                "Mistral 7B - Instruct",
                "Mixtral 8X7B - Instruct",]
        }
        this.get_datasets = this.get_datasets.bind(this)
        this.set_datasets = this.set_datasets.bind(this)
        this.setIsLoading = this.setIsLoading.bind(this);
    }

    componentDidMount(props, state) {
        this.get_datasets()
        if (this.state.searchValue !== null) {
            setTimeout(() => {
                this.setState({ loading: false })
            }, 1100)
        }
    }

    setIsLoading(loading) {
        this.setState({ loading })
    }

    set_datasets(datasets) {
        this.setState({ datasets })
    }

    get_datasets = async () => {
        const url = `${get_base_url(origin)}/datasets`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ "value": "40b3a00e282ee2db1338c3bba881b99125fc3ba1d7f5c29232ce1ad63fab1e75" }),
        });
        if (!response.ok) {
            console.log(`Error getting datasets: ${response.status} ${response.statusText}`);
        }

        // const responseJson = await response.json();
        // const datasets = responseJson.datasets.map((dataset_params, index) => {
        //     return {
        //         ...dataset_params,
        //         key: index,
        //         dataset_params: dataset_params
        //     }
        // })
        this.setState({ datasets: get_default_benchmarks_table_data() }) //TODO: change it to datasets: datasets
    }

    onModelsChange = (models) => {
        this.setState({ currentModelsOptions: models })
    };

    onDatasetSelect = (searchValue) => {
        this.setState({ showSpecificData: true, searchValue: searchValue, loading: true }, () => {
            setTimeout(() => {
                this.setState({ loading: false })
            }, 1100)
        })
    };

    onVocabInputChange = (event) => {
        this.setState({ vocabValue: event.target.value })
    };

    onDatasetSearch = (currentText) => {
        const currentOptions = datasetsOptions.filter(a => {
            console.log(a.value)
            return a.value.toLowerCase().includes(currentText.toLowerCase())
        })
        this.setState({ currentOptions, searchValue: currentText })
    };


    render() {
        return (<div
            className='explore-datasets page-content-shell'
        >
            <div style={{ paddingTop: "10px" }}>
                <Card hoverable>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Dataset:</div>
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: "10px" }}>
                        <AutoComplete
                            value={this.state.searchValue}
                            options={this.state.currentOptions}
                            onSearch={this.onDatasetSearch}
                            onSelect={this.onDatasetSelect}
                            style={{ width: "100%", flex: 1, marginRight: "10px" }}
                            placeholder={<div><SearchOutlined /> Select Dataset</div>} />
                        <Tooltip title="reset" style={{ cursor: 'pointer' }}>
                            <Button
                                onClick={() => { this.setState({ showSpecificData: false, searchValue: "", showVocabResult: false, vocabValue: "" }) }}
                                style={{ color: colors.buttonsBlue, borderColor: colors.buttonsBlue, cursor: 'pointer' }}
                            >
                                <RollbackOutlined />
                            </Button></Tooltip>
                    </div>
                </Card>
                {this.state.searchValue && this.state.loading && <div style={{ color: colors.buttonsBlue, fontSize: "80px", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30vh' }}>
                    <LoadingOutlined />
                </div>}
                {!this.state.loading && this.state.showSpecificData && <div>
                    <Card style={{ flex: 1, marginTop: "10px", marginRight: "10px", ...subStatisticCardStyle }}>
                        <Table
                            title={() => <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Processed Dataset Info:</div>}
                            style={{ flex: 1 }}
                            {...tableProps}
                            showHeader
                            columns={processedDataInfoColumns}
                            dataSource={processedDataInfo}
                        />
                    </Card>
                    <Card hoverable style={{ paddingLeft: "10px", paddingRight: "10px", marginBottom: "10px", marginTop: "10px" }}>
                        <Table
                            title={() => <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Examples:</div>}
                            {...tableProps}
                            columns={examplesColumns}
                            dataSource={examplesData}
                            pagination={{
                                pageSize: 4,
                            }}
                            showHeader={true}
                        />
                    </Card>
                    <Statistics
                        sampleSize={this.state.sampleSize}
                        onSampleSizeChanged={(value) => { this.setState({ sampleSize: value }) }}
                    />
                    <CheckModels
                        currentOptions={this.state.currentModelsOptions}
                        allOptions={modelsOptions}
                        vocabValue={this.state.vocabValue}
                        onVocabInputChange={this.onVocabInputChange}
                        showVocabResult={this.state.showVocabResult}
                        onVocabClick={() => {
                            this.setState({ showVocabResult: true })
                        }}
                        onVocabReset={() => { this.setState({ showVocabResult: false, vocabValue: "" }) }}
                        showPerplexity={this.state.showPerplexity}
                        onPerplexityClick={() => {
                            this.setState({ showPerplexity: true })
                        }}
                        onModelsChange={this.onModelsChange}
                        goToTrain={this.props.goToTrain}
                        currentDataset={this.state.searchValue}
                        moveToPlayground={this.props.moveToPlayground}
                    />
                </div>}
                {!this.state.showSpecificData && <div
                    style={{ color: "#b3b1b12e", fontSize: "300px", display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
                    <SearchOutlined />
                </div>}
            </div>
        </div>);
    }
}


